import { useEffect, useState } from "react";

export const EASE = [0.22, 1, 0.36, 1];

export function useReducedFx() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const small = window.matchMedia("(max-width: 900px)");
    const update = () => setReduced(mq.matches || small.matches);
    update();
    mq.addEventListener("change", update);
    small.addEventListener("change", update);
    return () => { mq.removeEventListener("change", update); small.removeEventListener("change", update); };
  }, []);
  return reduced;
}
